<template lang="pug">
div(v-if="!currentUserStore.currentUser.role_is_limited")
  div(
    ref="tooltipWrapper"
    data-toggle="tooltip"
    data-container="body"
    title="Export"
    @click="hideTooltip"
    @mouseleave="hideTooltip"
  )
    button.btn.btn-default.dropdown-toggle(
      ref="exportButton"
      :class="buttonClasses"
      type="button"
      data-toggle="dropdown"
    )
      i.fa.fa-download
      span.export-label(v-if="!hideLabel")
        |
        | Export
      i.fa.fa-caret-down
    ul.dropdown-menu.pull-right
      li.dropdown-header Export to...
      li(v-for="exportFormat in exportFormatsStore.forStories")
        a(@click="routeTo({ path: `export_formats/${exportFormat.id}` })" target="new")
          | {{ exportFormat.name }}
      li
        a(@click="routeTo({ extension: 'pdf' })") PDF from story text
      li
        a(@click="routeTo({ extension: 'zip' })") Zip all story assets
      li
        a.email-export(@click="exportViaEmail()")
          | Email
      li
        a.communityq-export(@click="publishToCommunityQ()" :class="{ locked: locked }")
          | Web publish
</template>

<script>
  import { sync } from 'vuex-pathify'
  import { mapGetters } from 'vuex'
  import { mapStores } from 'pinia'
  import { useCommunityqPublishingStore } from '@/stores/communityq_publishing.js'
  import { useCurrentUserStore } from '@/stores/current_user.js'
  import { useEmailExportingStore } from '@/stores/email_exporting.js'
  import { useExportFormatsStore } from '@/stores/export_formats.js'

  export default {
    props: {
      storyId: {
        type: Number,
        required: true
      },

      storyName: {
        type: String,
        required: false
      },

      buttonClasses: {
        type: Array,
        default: () => []
      },

      locked: {
        type: Boolean,
        default: () => false
      },

      hideLabel: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('story', [
        'isDirty'
      ]),
      ...mapStores(
        useCommunityqPublishingStore,
        useCurrentUserStore,
        useEmailExportingStore,
        useExportFormatsStore
      )
    },

    async mounted() {
      await this.currentUserStore.fetchOnce()
      await this.exportFormatsStore.fetchOnce()
    },

    methods: {
      hideTooltip() {
        if (this.$refs.tooltipWrapper) {
          jQuery(this.$refs.tooltipWrapper).tooltip('hide')
        }
      },

      checkDirty() {
        return new Promise((resolve, _reject) => {
          if(this.isDirty) {
            // This feels a bit hacky but there is some very component-specific, and fairly
            // comlpex logic in the StoryForm that would be hard to reproduce outside of it.
            // Still there may be a better way.
            if(this.$parent.save) {
              this.$parent.save().then(() => { resolve(true) })
            } else {
              resolve(true)
            }
          } else {
            resolve(true)
          }
        })
      },

      routeTo({ path, extension } = {}) {
        this.$store.dispatch('messages/addNotice', 'Exporting...')

        this.checkDirty().then(() => {
          const url = (
            this.addExtension(this.addPath(`/stories/${this.storyId}`, path), extension)
          )

          window.location = url
        })
      },

      exportViaEmail() {
        this.checkDirty().then(() => {
          this.emailExportingStore.storyId = this.storyId
        })
      },

      publishToCommunityQ() {
        if (this.locked) return

        this.checkDirty().then(() => {
          this.communityqPublishingStore.storyIds = [this.storyId]
        })
      },

      addPath(url, path) {
        if(!path) return url;

        return `${url}/${path}`;
      },

      addExtension(url, extension) {
        if(!extension) return url;

        return `${url}.${extension}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*
    Links without an href have a text select pointer by default,
    but we want them to act just like links.
  */
  a {
    cursor: pointer;

    &.locked {
      color: #ccc;
      cursor: not-allowed;

      &:hover {
        color: #ccc;
        background-color: transparent;
      }
    }
  }
  .export-label {
    margin-right: 5px;
  }
</style>